import React, { useEffect } from "react";
import TriangularTrialUp from "../assets/triangular/triangular-bg-trial-up.svg";
import TriangularTrialDown from "../assets/triangular/triangular-bg-trial-down.svg";
import "./ProductTrial.css";
import MagicFeedback from "@magicfeedback/native";

function ProductTrial() {
  // Initialize and render the MagicFeedback SDK
  useEffect(() => {
    MagicFeedback.init();

    // Get guide
    const contactForm = MagicFeedback.form(
      "e95b7390-d587-11ee-905b-03387063b532",
      "28f10ab552b1f6f33ddfc90f73e0238a"
    );

    contactForm.generate("magicfeedback-contact-container", {
      addButton: true,
      sendButtonText: "Book a demo",
      addSuccessScreen: true,
      questionFormat: "slim",
      afterSubmitEvent: ({
        loading,
        progress,
        total,
        response, // Response of the server if everything is ok
        error, // Error of the server if something is wrong
      }) => {
        if (error) {
          // TODO: Show error message
        }

        //TODO: Show message of success
      },
    });

    //magicfeedback-success
  }, []);

  return (
    <div>
      <img
        src={TriangularTrialUp}
        alt="background blue triangular"
        className="triangular-bg-trial"
      />
      {/* <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                viewBox="0 0 2175 96"
                fill="none"
            >
                <path d="M2175 0V96H1087.5H0L2175 0Z" fill="#0F172A" />
            </svg> */}
      <section className="product-trial">
        <div className="product-trial-container">
          <div className="product-trial-content">
            <h2>Get our guide on collecting customer feedback</h2>
            <p>
              Unlock your access to our tried and tested methods of collecting
              quality customer feedback. Complete with feedback questions
              examples. Unlock your access to our free e-book with step-by-step
              guides.
            </p>
          </div>
          <div id="magicfeedback-contact-container" className="magicfeedback-contact-container">
            {/** MagicFeedback SDK space */}
          </div>
        </div>
      </section>
      <img
        src={TriangularTrialDown}
        alt="background blue triangular"
        className="triangular-bg-trial"
      />
    </div>
  );
}

export default ProductTrial;
